import { render, staticRenderFns } from "./About1.vue?vue&type=template&id=9819a040"
import script from "./About1.vue?vue&type=script&lang=js"
export * from "./About1.vue?vue&type=script&lang=js"
import style0 from "./About1.vue?vue&type=style&index=0&id=9819a040&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports